export default __webpack_public_path__ + "static/media/640_portfolio04-nl-mobile.73bf5ead.png";